import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Header,
  Form,
  Radio,
  Loader,
  Dimmer,
  Grid,
  Button,
  Confirm,
} from 'semantic-ui-react';
import {
  getBusinessDetails,
  openUpdateBusinessPackageModal,
  setSelectedBusinessPackage,
  getRecurringPaymentsDetails,
  cancelRecurringPayment,
  showCancelRecurringPaymentConfirmation,
  closeCancelRecurringPaymentConfirmation,
} from 'state/business/actions';
import UpdateBusinessPackageConfirmationModal from './UpdateBusinessPackageConfirmationModal';

const BusinessProfile = props => {
  const {
    businessDetailsData,
    allBusiness,
    gettingBusinessDetails,
    updatingBusinessPackage,
    dispatch,
    recurringPaymentsData,
    cancelRecurringPaymentConfirmation,
    cancellingRecurringPayment,
  } = props;

  const activeBusiness = businessDetailsData.data;

  const activeRecurringPayments = recurringPaymentsData.data;

  useEffect(() => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;
    dispatch(getBusinessDetails({ businessId }));
    dispatch(getRecurringPaymentsDetails({ businessId }));
  }, [allBusiness.activeIndex, allBusiness.data, dispatch]);

  const handlePackageClick = (e, { value }) => {
    let isEnterprise = true;
    if (value !== 'ENTERPRISE') isEnterprise = false;
    if (businessDetailsData.data.is_enterprise !== isEnterprise) {
      dispatch(setSelectedBusinessPackage(value));
      dispatch(openUpdateBusinessPackageModal());
    }
  };

  const dateTimeFormat = date => {
    const jsonDate = date.toJSON().slice(0, 10);
    return `${jsonDate.slice(8, 10)}/${jsonDate.slice(5, 7)}/${jsonDate.slice(
      0,
      4
    )}`;
  };

  const constructAddress = () => {
    const businessData = businessDetailsData.data;
    let addressString = '';
    if (businessData.address) {
      addressString += businessData.address;
    }

    if (businessData.kecamatan) {
      if (addressString) {
        addressString += `, ${businessData.kecamatan}`;
      } else {
        addressString += businessData.kecamatan;
      }
    }

    if (businessData.city) {
      if (addressString) {
        addressString += `, ${businessData.city}`;
      } else {
        addressString += businessData.city;
      }
    }

    if (businessData.province) {
      if (addressString) {
        addressString += `, ${businessData.province}`;
      } else {
        addressString += businessData.province;
      }
    }

    if (businessData.postal_code) {
      if (addressString) addressString += ` ${businessData.postal_code}`;
    }

    return addressString;
  };

  const handleClickCancelRecurringPayment = () => {
    dispatch(showCancelRecurringPaymentConfirmation());
  };

  const handleConfirmCancelRecurringPayment = () => {
    const businessId = allBusiness.data[allBusiness.activeIndex].id;

    dispatch(closeCancelRecurringPaymentConfirmation());
    dispatch(
      cancelRecurringPayment(businessId, () =>
        dispatch(getRecurringPaymentsDetails({ businessId }))
      )
    );
  };

  return (
    <>
      <UpdateBusinessPackageConfirmationModal />
      <Confirm
        open={cancelRecurringPaymentConfirmation}
        confirmButton={{ negative: true, content: 'Confirm' }}
        onConfirm={handleConfirmCancelRecurringPayment}
        onCancel={() => dispatch(closeCancelRecurringPaymentConfirmation())}
        header="Confirm Cancel Recurring Payment"
        content="Are you sure to perform this operation? Any progress cannot be rolled back"
      />
      <Dimmer
        active={
          gettingBusinessDetails ||
          updatingBusinessPackage ||
          cancellingRecurringPayment
        }
      >
        <Loader size="massive">Loading</Loader>
      </Dimmer>
      {businessDetailsData.data && allBusiness.data ? (
        <div>
          <Header as="h3" dividing>
            Business
          </Header>
          <Grid>
            <Grid.Row style={{ padding: '8px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Business ID</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.id}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Business Name</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.name}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Address</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {constructAddress()}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Subscription</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.business_subscription[0]}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Registered Date</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {dateTimeFormat(new Date(activeBusiness.registered_date))}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Expiration</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {dateTimeFormat(new Date(activeBusiness.expired_at))}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 8px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Is Deleted</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.is_deleted.toString()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Header as="h3" dividing>
            Owner
          </Header>
          <Grid>
            <Grid.Row style={{ padding: '8px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Owner ID</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_id}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Owner Name</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_name}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Email</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.owner_email}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Phone Number</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                : {activeBusiness.phone}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row style={{ padding: '2px 0px 8px 0px' }}>
              <Grid.Column mobile={7} tablet={6} computer={5}>
                <li>Last Login</li>
              </Grid.Column>
              <Grid.Column mobile={9} tablet={10} computer={11}>
                :{' '}
                {(() => {
                  if (!activeBusiness.last_sign_in_at) return null;
                  return dateTimeFormat(
                    new Date(activeBusiness.last_sign_in_at)
                  );
                })()}
              </Grid.Column>
            </Grid.Row>
          </Grid>

          {activeRecurringPayments && (
            <>
              <Header as="h3" dividing>
                Recurring Payment
              </Header>
              <Grid>
                <Grid.Row style={{ padding: '8px 0px 0px 0px' }}>
                  <Grid.Column mobile={7} tablet={6} computer={5}>
                    <li>RPI Code</li>
                  </Grid.Column>
                  <Grid.Column mobile={9} tablet={10} computer={11}>
                    : {activeRecurringPayments.rpi_code}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
                  <Grid.Column mobile={7} tablet={6} computer={5}>
                    <li>Binding Date</li>
                  </Grid.Column>
                  <Grid.Column mobile={9} tablet={10} computer={11}>
                    :{' '}
                    {dateTimeFormat(
                      new Date(activeRecurringPayments.created_at)
                    )}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
                  <Grid.Column mobile={7} tablet={6} computer={5}>
                    <li>Customer ID</li>
                  </Grid.Column>
                  <Grid.Column mobile={9} tablet={10} computer={11}>
                    : {activeRecurringPayments.customer_id}
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: '2px 0px 0px 0px' }}>
                  <Grid.Column mobile={7} tablet={6} computer={5}>
                    <li>Billing Cycle</li>
                  </Grid.Column>
                  <Grid.Column mobile={9} tablet={10} computer={11}>
                    : {`${activeRecurringPayments.month} Month(s)`}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Grid columns="equal">
                <Grid.Column only="computer" />
                <Grid.Column only="computer" />
                <Grid.Column floated="right" textAlign="right">
                  <Button
                    color="red"
                    onClick={handleClickCancelRecurringPayment}
                  >
                    Cancel Recurring Payment
                  </Button>
                </Grid.Column>
              </Grid>
            </>
          )}

          <Header as="h3" dividing>
            Package
          </Header>
          <Form>
            <Form.Field>
              <Radio
                label="Basic"
                name="radioGroup"
                value="BASIC"
                checked={!activeBusiness.is_enterprise}
                onChange={handlePackageClick}
              />
            </Form.Field>
            <Form.Field>
              <Radio
                label="Enterprise"
                name="radioGroup"
                value="ENTERPRISE"
                checked={activeBusiness.is_enterprise}
                onChange={handlePackageClick}
              />
            </Form.Field>
          </Form>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

const mapStateToProps = ({ business }) => ({
  businessDetailsData: business.businessDetailsData,
  allBusiness: business.allBusiness,
  updatingBusinessPackage: business.updatingBusinessPackage,
  gettingBusinessDetails: business.gettingBusinessDetails,
  recurringPaymentsData: business.recurringPaymentsData,
  cancelRecurringPaymentConfirmation:
    business.cancelRecurringPaymentConfirmation,
  cancellingRecurringPayment: business.cancellingRecurringPayment,
});

BusinessProfile.propTypes = {
  dispatch: PropTypes.func.isRequired,
  businessDetailsData: PropTypes.object.isRequired,
  allBusiness: PropTypes.object.isRequired,
  updatingBusinessPackage: PropTypes.bool.isRequired,
  gettingBusinessDetails: PropTypes.bool.isRequired,
  recurringPaymentsData: PropTypes.object.isRequired,
  cancelRecurringPaymentConfirmation: PropTypes.bool.isRequired,
  cancellingRecurringPayment: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(BusinessProfile);
